export default __webpack_public_path__ + "static/media/handshake.df099a24.svg";